import { Component, OnInit, Input, EventEmitter, Output, ViewChild, TemplateRef } from '@angular/core';

import {MatDialog} from '@angular/material/dialog';

import { TypedefdialogComponent } from '../typedefdialog/typedefdialog.component';

import { VehiculeparamComponent } from '../vehiculeparam/vehiculeparam.component';

import { PredefparamchooseComponent } from '../predefparamchoose/predefparamchoose.component';

import { RecurrentComponent } from '../recurrent/recurrent.component';

import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';

import { ServicepoolService } from '../services/servicepool.service';



@Component({
  selector: 'app-primeconfig',
  templateUrl: './primeconfig.component.html',
  styleUrls: ['./primeconfig.component.css']
})
export class PrimeconfigComponent implements OnInit {

  Tabval = "" ;

  newParam = ""  ;

  theChoosenDataType = "" ;

  @Input() garantie : any ;

  @Output() DeletionOrderToReturnBackEvent = new EventEmitter<string>();

  checkStatus = [] ;

  checkboxEditDeactivate = [] ;

  eltsType = [] ;

  saveBtnState = "done_all" ;

  primenameedit = "edit" ;

  baseElement = "" ;

  editprimename = 0 ;

  configPrimeBtn = false ;

  primeconfigObject : any ;

  retourClientWS : any ;

  headClass = "card-header card-header-tabs card-header-primary" ;

  rowNumber = 0 ;
  resultArray = [] ;
  subTabLength = 2 ;

  checkedParams : any ;
  
  @Input() configuration : any[] ;

  @Input() assurancetype : any ;

  @Input() compagnie : any ;


  @ViewChild('spinnerDialog') spinnerDialog: TemplateRef<any>;

  spinnerDialogRef : any ;


  constructor(public dialog: MatDialog,  private configServer: ServicepoolService) { }

  ngOnInit(): void {
  	var onChunkArray = [] ;
  	var index = 0 ;
  	this.resultArray = this.garantie.params.reduce((indexDead, item ) => { 
  	const chunkIndex = Math.floor(index/this.subTabLength)

  	if(!onChunkArray[chunkIndex]) {
  	  onChunkArray[chunkIndex] = [] // start a new chunk
  	}

  	onChunkArray[chunkIndex].push(item) ;

  	index++ ;

  	return onChunkArray ;
  	}, []) ;

    this.checkedParams =  this.garantie.params;


    if(this.garantie.params.length==1 && this.garantie.params[0].nomFrmt=="Franchise"){
      this.checkStatus.push(true) ;
      this.checkboxEditDeactivate.push(false) ;
      this.eltsType.push([]) ;
    }
    else{
      for (var i = 0; i< this.garantie.params.length; i++) {
        this.checkStatus.push(true) ;
        this.checkboxEditDeactivate.push(false) ;
        this.eltsType.push([]) ;
      }
    }
  }



  initialize(){
    this.checkStatus = [] ;
    this.checkboxEditDeactivate = [] ;
    this.checkedParams = [] ;

    var onChunkArray = [] ;
    var index = 0 ;
    this.resultArray = this.garantie.params.reduce((indexDead, item ) => { 
    const chunkIndex = Math.floor(index/this.subTabLength)

    if(!onChunkArray[chunkIndex]) {
    onChunkArray[chunkIndex] = [] // start a new chunk
    }

    onChunkArray[chunkIndex].push(item) ;

    index++ ;

    return onChunkArray ;
    }, []) ;

    this.checkedParams =  this.garantie.params;


    if(this.garantie.params.length==1 && this.garantie.params[0].nomFrmt=="Franchise"){
      this.checkStatus.push(true) ;
      this.checkboxEditDeactivate.push(false) ;
      this.eltsType.push([]) ;
    }
    else{
      for (var i = 0; i< this.garantie.params.length; i++) {
        this.checkStatus.push(true) ;
        this.checkboxEditDeactivate.push(false) ;
        this.eltsType.push([]) ;
      }
    }

  }


  getAllPossibleParamsForThisGarantie(){

    this.openSpinnerDialog();
    console.log("Here we go 187 !!! ") ;
    this.configServer.getAllPossibleParamsForThisGarantie("thiswii", this.garantie.intitule).then( (retourbi) => {    
    this.closeSpinnerDialog() ;
      this.retourClientWS = retourbi ;
      var statutreq = this.retourClientWS.statutreq;
      console.log(this.retourClientWS.data) ;
      if(statutreq==1){
        console.log("Done") ;
        //this.allBigCategories = this.retourClientWS.data ; 
      }
      else{
        console.log("Failed") ;
      }
    }) ;    
  }


  soppiMbirrMi(domaine){

	  this.Tabval = (this.Tabval==this.garantie.intitule)? "-":this.garantie.intitule ;
  }

  jsonElementFactory(baseElmt, newProp, intitule, type){
  	if (baseElmt=="")
  		return '{"primeName": "'+this.garantie.params.replace(/\s+/g, '').normalize('NFD').replace(/[\u0300-\u036f]/g, "")+'", "primeNameLibelle": "'+this.garantie.intitule+'", "params": [{'+'"name" : "'+newProp+'", "intitule": "'+intitule+'", "type": '+type+' }]}' ;  
  	else
  		return baseElmt.substring(0, baseElmt.length-2)+', {"name" : "'+newProp+'", "intitule": "'+intitule+'", "type": '+type+' }]}' ;
  }

  jsonElementFactoryFinale(baseElmt, formulation){

      return baseElmt.substring(0, baseElmt.length-1)+', "formulation" : '+formulation+'}' ;
  }

  openDialog(nomParam, typeIndex) {
    const dialogRef = this.dialog.open(TypedefdialogComponent, {
      data: {
        ParamsName: {"nomFrmt": this.formatThisString(nomParam), "intitule": nomParam, "type":"simple"} ,
        typechoice: ["***"]
      },
       disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(result) ;
      this.eltsType[typeIndex] = result ;
    });
  }

  openDialogVehicParam() {
    const dialogRef1 = this.dialog.open(VehiculeparamComponent, {
      data: {
        ParamsName : [
            {"nomFrmt": this.formatThisString("Puissance"), "intitule": "Puissance", "type":"predefvehiv"},
            {"nomFrmt": this.formatThisString("Energie"), "intitule": "Energie", "type":"predefvehiv"},
            {"nomFrmt": this.formatThisString("Nombre de Place"), "intitule": "Nombre de Place", "type":"predefvehiv"},
            {"nomFrmt": this.formatThisString("Poids Total en Charge Autorisé (PTAC)"), "intitule": "Poids Total en Charge Autorisé (PTAC)", "type":"predefvehiv"},
            {"nomFrmt": this.formatThisString("Poids Vide"), "intitule": "Poids Vide", "type":"predefvehiv"},
            {"nomFrmt": this.formatThisString("Charge Utile"), "intitule": "Charge Utile", "type":"predefvehiv"},
            {"nomFrmt": this.formatThisString("Poids Total Roulant (PTR)"), "intitule": "Poids Total Roulant (PTR)", "type":"predefvehiv"},
            {"nomFrmt": this.formatThisString("Cylindre"), "intitule": "Cylindre", "type":"predefvehiv"},
            {"nomFrmt": this.formatThisString("Date mise en circulation"), "intitule": "Date mise en circulation", "type":"predefvehiv"},
            {"nomFrmt": this.formatThisString("Genre"), "intitule": "Genre", "type":"predefvehiv"},
            {"nomFrmt": this.formatThisString("Carosserie"), "intitule": "Carosserie", "type":"predefvehiv"},
            {"nomFrmt": this.formatThisString("Date Mise en Circulation"), "intitule": "Date Mise en Circulation", "type":"predefvehiv"}
        ]
      },

       disableClose: true
    });

    dialogRef1.afterClosed().subscribe(result => {
      console.log("Result For Vehicule Config") ;      
      var choosenVehicParams = JSON.parse(result) ;      

      for (var i = 0; i<choosenVehicParams.choosenParams.length; i++) {
        this.garantie.params.push(choosenVehicParams.choosenParams[i]) ;
        this.eltsType.push(choosenVehicParams.typos[i]) ;

        this.checkStatus.push(true) ;
        this.checkboxEditDeactivate.push(false) ;
        var onChunkArray = [] ;
        var index = 0 ;
        this.resultArray = this.garantie.params.reduce((indexDead, item ) => { 
          const chunkIndex = Math.floor(index/this.subTabLength) ;

          if(!onChunkArray[chunkIndex]) {
            onChunkArray[chunkIndex] = [] ; 
          }
          onChunkArray[chunkIndex].push(item) ;
          index++ ;
          return onChunkArray ;
        }, []) ; 
      }
    });
  }


  openDialogRecurrParam() {
    const dialogRef1 = this.dialog.open(RecurrentComponent, {
      data: {
        ParamsName : [
        ]
      },

       disableClose: true
    });

    dialogRef1.afterClosed().subscribe(result => {
      console.log("Result For Vehicule Config") ;      
      var choosenVehicParams = JSON.parse(result) ;      

      for (var i = 0; i<choosenVehicParams.choosenParams.length; i++) {
        this.garantie.params.push(choosenVehicParams.choosenParams[i]) ;
        this.eltsType.push(choosenVehicParams.typos[i]) ;

        this.checkStatus.push(true) ;
        this.checkboxEditDeactivate.push(false) ;
        var onChunkArray = [] ;
        var index = 0 ;
        this.resultArray = this.garantie.params.reduce((indexDead, item ) => { 
          const chunkIndex = Math.floor(index/this.subTabLength) ;

          if(!onChunkArray[chunkIndex]) {
            onChunkArray[chunkIndex] = [] ; 
          }
          onChunkArray[chunkIndex].push(item) ;
          index++ ;
          return onChunkArray ;
        }, []) ; 
      }
    });
  }



  openDialogPredefCustomParam() {
    const dialogRef1 = this.dialog.open(PredefparamchooseComponent, {
      data: {},
       disableClose: true
    });

    dialogRef1.afterClosed().subscribe(result => {
      console.log("Result For Vehicule Config") ;      
      var choosenVehicParams = JSON.parse(result) ;      

      for (var i = 0; i<choosenVehicParams.choosenParams.length; i++) {
        this.garantie.params.push(choosenVehicParams.choosenParams[i]) ;
        this.eltsType.push(choosenVehicParams.typos[i]) ;

        this.checkStatus.push(true) ;
        this.checkboxEditDeactivate.push(false) ;
        var onChunkArray = [] ;
        var index = 0 ;
        this.resultArray = this.garantie.params.reduce((indexDead, item ) => { 
          const chunkIndex = Math.floor(index/this.subTabLength) ;

          if(!onChunkArray[chunkIndex]) {
            onChunkArray[chunkIndex] = [] ; 
          }
          onChunkArray[chunkIndex].push(item) ;
          index++ ;
          return onChunkArray ;
        }, []) ; 
      }
    });
  }


  onPrimeChoose(event, i, j) {
  	//Danouy reformaté chaine bi pour dindi ci caractères yi am ci francais tei nekoul ci anglais ... Ce qui est fait sur le code à partir de la fonction normalize
  	if (event.target.checked){
  		this.checkStatus[j+2*i]=true ;
      var typeIndex = j+2*i ;
  		//this.openDialog(this.ParamsName[j+2*i], typeIndex) ;
  	}
  	else{
  	  	console.log("UNCHECKED "+event.target.value) ;
    		this.checkStatus[j+2*i]=false ;	  	
  	}
  	console.log(this.baseElement);	
  }


  ajouterParam(){

  	if (this.newParam != "" && this.theChoosenDataType!=""  && this.saveBtnState=="done_all"){
    	this.garantie.params.push( {"nomFrmt": this.formatThisString(this.newParam), "intitule": this.newParam, "type":"simple", "datatype": this.theChoosenDataType}) ;

  	  this.checkStatus.push(false) ;
  		this.checkboxEditDeactivate.push(false) ;

  		var onChunkArray = [] ;

  		var index = 0 ;

  		this.resultArray = this.garantie.params.reduce((indexDead, item ) => { 
  		const chunkIndex = Math.floor(index/this.subTabLength) ;

  		if(!onChunkArray[chunkIndex]) {
    		onChunkArray[chunkIndex] = [] ; 
  		}

  		onChunkArray[chunkIndex].push(item) ;

  		index++ ;

  		return onChunkArray ;
  		}, []) ; 

      this.theChoosenDataType = "" ;
  		this.newParam = "" ;
  	}
  }

  savePrime(){

  	if (this.saveBtnState=="done_all"){

  		for (var i = 0; i< this.checkboxEditDeactivate.length; i++) {
  			this.checkboxEditDeactivate[i] = true ;
  		}
      var allParamsConfigs = [] ;
  		for (var i = 0; i< this.checkStatus.length; i++) {
  			if(this.checkStatus[i] == false){
  				this.garantie.params.splice(i, 1 ) ;
			  }
		  }      

      this.initialize() ;

	  	this.saveBtnState = "edit" ; 
      console.log(this.garantie);
      this.configPrimeBtn = true ;

  	}else{
      for (var i = 0; i< this.checkboxEditDeactivate.length; i++) {
      	this.checkboxEditDeactivate[i] = false ;
      }
      this.headClass = "card-header card-header-tabs card-header-primary" ;
      this.saveBtnState = "done_all" ;
      this.configPrimeBtn = false ;  		
    }

  }

  configPrime(){

    var choosenParams =[] ;
    console.log(this.garantie.params) ;

    choosenParams =  this.copyThisArray(this.garantie.params) ;

    for (var i = 0; i< choosenParams.length; i++) {
      if(choosenParams[i].nomFrmt=="Energie"){
        choosenParams.push({"nomFrmt": this.formatThisString("Essence"), "intitule": "Essence", "type":"predefvehiv"}  ) ; 
        choosenParams.push({"nomFrmt": this.formatThisString("Diesel"), "intitule": "Diesel", "type":"predefvehiv"}  ) ;
        choosenParams.push({"nomFrmt": this.formatThisString("Hybride"), "intitule": "Hybride", "type":"predefvehiv"}  ) ;
        choosenParams.push({"nomFrmt": this.formatThisString("Electrique"), "intitule": "Electrique", "type":"predefvehiv"}  ) ;
      }
      if(choosenParams[i].type=="custompredef"){
        console.log("THERERERER") ;
        console.log(choosenParams[i]) ;
        for (var k = 0; k< choosenParams[i].values.length; k++) {
          choosenParams.push({"nomFrmt": choosenParams[i].values[k], "intitule":choosenParams[i].values[k], "type":"custompredefval"}  ) ; 
        }
      }
    }

    this.openDialogForPrimeConfig(this.garantie.intitule, 1, choosenParams, this.garantie.formule) ;
  }


  copyThisArray(arrayToCopy){
    var copyArray = [] ;
    for (var i = 0; i< arrayToCopy.length; i++) {
      copyArray.push(arrayToCopy[i]) ;
    }
    return copyArray ;
  }

  openDialogForPrimeConfig(nomPrime, typeIndex, params, laFormule) {

    var predefinedVariables = params ;

    const dialogRef = this.dialog.open(TypedefdialogComponent, {
      data: {
        ParamsName: nomPrime,
        typechoice: predefinedVariables,
        formule: laFormule
      },
       disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(result) ;

      this.garantie.formule = JSON.parse(result) ;

      this.headClass = "card-header card-header-tabs card-header-danger" ;

      var toReturn = {"ordre":"saveconfig", "garantie": this.garantie }; 

      this.DeletionOrderToReturnBackEvent.emit(JSON.stringify(toReturn)) ;

    });
  }

  editPrime(){
    if(this.editprimename==0){
      this.editprimename = 1 ;
      this.primenameedit = "done";      
    }else{

      var toReturn = {"ordre":"rename", "garantie": this.garantie }; 

      this.DeletionOrderToReturnBackEvent.emit(JSON.stringify(toReturn)) ;
      this.editprimename = 0 ;
      this.primenameedit = "edit";            
    }
  }

  deletePrime(){

    var data = {"title": "Suppression Garantie", "message": "Voulez-vous vraiment supprimer cette Garantie ?"} ;
    const dialogRef1 = this.dialog.open(ConfirmationDialogComponent, {data});
    
    dialogRef1.afterClosed().subscribe(result => {
      console.log(result) ;
      if(result=="dlt"){
          var toReturn = {"ordre":"fermer", "garantie": this.garantie  }; 
          this.DeletionOrderToReturnBackEvent.emit(JSON.stringify(toReturn)) ;
      }
      else{
        console.log("") ;        
      }

    });
  }

  makeMandatory(){
    this.garantie.mandatory = true;
    var toReturn = {"ordre":"option", "garantie": this.garantie  }; 
    this.DeletionOrderToReturnBackEvent.emit(JSON.stringify(toReturn)) ;
  }

  releaseMandatory(){
    this.garantie.mandatory = false ;
    var toReturn = {"ordre":"option", "garantie": this.garantie }; 
    this.DeletionOrderToReturnBackEvent.emit(JSON.stringify(toReturn)) ;
  }

  formatThisString(name){
    return name.replace(/\s+/g, '').normalize('NFD').replace(/[\u0300-\u036f]/g, "") ;
  }


  openSpinnerDialog() {
    this.spinnerDialogRef = this.dialog.open(this.spinnerDialog);
  }

  closeSpinnerDialog() {
    this.spinnerDialogRef.close();
  }



}
